/**
 * Provides a requireJS dependency injection of the global window.
 * Useful in Unit Tests for mocking the window functionality.
 */
define('helpers/window',[],function () {
    'use strict';
    return window;
});
